module.exports = __webpack_public_path__ + "img/pinterest.40f0d1c.svg";